import React from 'react';
import { Col, Form } from 'react-bootstrap';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';

const FooterPaginacionOrdenes = ({
    pageSize,
    totalRecords,
    pageNumber,
    onPageSizeChange,
    onNextPage,
    onPreviousPage,
    onGotoPage
}) => {
    return (
        <>
            <Col xs="auto" className="d-flex align-items-center">
                <Form.Label className="mb-0 me-2 fs--2 text-600">Mostrar:</Form.Label>
                <Form.Select
                    size="sm"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    style={{ width: 'auto' }}
                >
                    <option value={10}>10 filas</option>
                    <option value={15}>15 filas</option>
                    <option value={30}>30 filas</option>
                </Form.Select>
            </Col>
            <Col xs="auto">
                <AdvanceTableFooter
                    rowCount={totalRecords}
                    navButtons={true}
                    pageIndex={pageNumber - 1}
                    canPreviousPage={pageNumber > 1}
                    canNextPage={pageNumber < Math.ceil(totalRecords / pageSize)}
                    nextPage={onNextPage}
                    previousPage={onPreviousPage}
                    gotoPage={onGotoPage}
                />
            </Col>
        </>
    );
};

FooterPaginacionOrdenes.propTypes = {
    pageSize: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onNextPage: PropTypes.func.isRequired,
    onPreviousPage: PropTypes.func.isRequired,
    onGotoPage: PropTypes.func.isRequired
};

export default FooterPaginacionOrdenes;